<template>
  <v-container
    grid-list-md
    fluid
    class="pa-1"
  >
    <v-layout
      v-if="loading"
      row
      wrap
      justify-center
    >
      <v-progress-circular
        :size="64"
        :width="3"
        indeterminate
        color="primary"
      />
    </v-layout>
    <v-layout
      v-else
      column
      wrap
    >
      <v-flex>
        <v-toolbar
          color="white"
          light
          tabs
          class="max-shadow"
          style="border-radius:9px"
        >
          <v-toolbar-title>{{ vendor.vendorName }}</v-toolbar-title>

          <v-spacer />
          <v-btn
            color="primary"
            flat
            @click.native="deleteVendor"
          >
            Delete
          </v-btn>

          <v-tabs
            slot="extension"
            v-model="activeTab"
            centered
            color="white"
            slider-color="accent"
          >
            <v-tab key="restaurant">
              Restaurant
            </v-tab>
            <v-tab key="orders">
              Orders
            </v-tab>
            <v-tab key="vault">
              Documents Vault
            </v-tab>
          </v-tabs>
        </v-toolbar>
      </v-flex>
      <v-flex>
        <v-tabs-items
          :value="activeTab"
        >
          <v-tab-item key="restaurant">
            <restaurant :vendor-id="vendorId" />
          </v-tab-item>
          <v-tab-item key="orders">
            <orders :vendor-id="vendorId" />
          </v-tab-item>
          <v-tab-item key="vault">
            <files-vault :vendor-id="vendorId" />
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
      <v-dialog
        v-model="deleteDialog"
        persistent
        max-width="700px"
        transition="dialog-transition"
        lazy
      >
        <v-card class="max-shadow">
          <v-card-title class="headline">
            Remove Vendor?
          </v-card-title>
          <v-card-text class="subheading">
            Do you want to delete vendor {{ vendor.vendorName }}'s account?
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-spacer />
            <v-btn
              color="primary"
              flat
              @click="deleteDialog = false"
            >
              cancel
            </v-btn>
            <v-btn
              flat
              color="primary"
              @click="confirmDelete"
            >
              delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
import { firestore } from '@/firebase';

import FilesVault from './FilesVault';
import Restaurant from './Restaurant';
import Orders from './Orders';

export default {
  name: 'Vendor',
  components: {
    restaurant: Restaurant,
    orders: Orders,
    'files-vault': FilesVault
  },
  props: {
    vendorId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      vendor: {},
      loading: true,
      activeTab: null,
      deleteDialog: false
    };
  },
  mounted() {
    // fetch tenant details
    firestore
      .collection('vendors')
      .doc(this.vendorId)
      .get()
      .then(vendorSnapshot => {
        this.vendor = vendorSnapshot.data();
        this.loading = false;
      });
  },
  methods: {
    deleteVendor(){
      this.deleteDialog = true;
    },

    confirmDelete() {
      firestore
      .collection('vendors')
      .doc(this.vendorId)
      .delete()
      this.deleteDialog = false;
      //route back
      this.$router.back();
    }
  }
};
</script>
